import React, { useState, useEffect, useContext, useRef } from 'react'
import ResizeDetector from 'react-resize-detector'

import { withStyles } from '@material-ui/core/styles'

import { NavigationContext } from './NavigationController'
import Panel from './Panel'
import { useWindowSize } from '../utilities/useWindowSize'

import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  sidePane: {
    minWidth: 300,
    width: '20%',
  },
  sidePaneContainer: {
    // position: 'fixed',
    //overflow: 'scroll',
    paddingLeft: theme.spacing(2),
  },
  mainPane: {
    flexGrow: 1,
  },  
})

const DetailViewController = ({ theme, classes, children, sidePanels, ...props }) => {
  
  const { lastFetched, isFetching } = props  
  const { title, actionButtons, backButton } = props

  const [windowWidth, windowHeight] = useWindowSize()
  
  const navigationContext = useContext(NavigationContext)  

  const mainRef = useRef(null);
  const sideRef = useRef(null);

  const [sidePaneContainerStyle, setSidePane] = useState({
    position: 'absolute',
    // top: navigationContext.contentInset.top + theme.spacing(2) + 'px',
    height: windowHeight - navigationContext.contentInset.top + 'px',
    //width: '100%'
  })

  const handleScroll = () => {
    if (sideRef.current) {
      var currentPosition = window.pageYOffset;
      var initialSidePaneHeight = sideRef.current.offsetHeight
      var heightDelta = Math.abs(initialSidePaneHeight - sideRef.current.getBoundingClientRect().bottom)
      if (sideRef.current.getBoundingClientRect().bottom <= heightDelta) {
        setSidePane({
          ...sidePaneContainerStyle,
          // ['position']: 'fixed',
          // ['top']: -heightDelta
        })
      }

      if (currentPosition < heightDelta) {
        setSidePane({
          ...sidePaneContainerStyle,
          ['position']: 'absolute',
          ['top']: theme.spacing(2)
        })
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, []);
  
  return (
    <div className={classes.root}>
      <div className={classes.mainPane} ref={mainRef}>    
        <Panel 
          title={title}
          isMainPanel={true}
          actionButtons={lastFetched && actionButtons}
          backButton={backButton}
          inProgress={isFetching}
          >
          { false && props.isFetching &&
            <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
              <CircularProgress size='1.5rem' disableShrink={true} />        
            </Box>
          }                
            
          { children }
        </Panel>
      </div>
      { sidePanels && 
        <div className={classes.sidePane}>        
          <ResizeDetector
            handleWidth
            render={({ width }) => (
              <div className={classes.sidePaneContainer}
                style={{ 
                    width: width, 
                    position: 'absolute',
                    ...sidePaneContainerStyle
                  }}
                ref={sideRef}
                >
                { lastFetched && sidePanels.reduce((p, n) => p ? [
                  ...p, <Box mt={2} />, n] : [n], null
                  )
                }
              </div>
            )}
          />
        </div>
      }
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(
  DetailViewController
)
